import './Portfolio.css';

function Portfolio() {
  // Ordered by performance (markup since our entry, then latest valuation).
  // Not alphabetical.
  const companies = [
    {
      name: 'Monad',
      url: 'https://monad.xyz',
      logo: '/logos/monad.svg',
      tagline: 'High-performance EVM blockchain'
    },
    {
      name: 'Alpen Labs',
      url: 'https://alpenlabs.io',
      logo: '/logos/alpen.svg',
      tagline: 'Bitcoin financial system'
    },
    {
      name: 'Medra',
      url: 'https://medra.ai',
      logo: '/logos/medra.svg',
      tagline: 'AI accelerates lab data generation'
    },
    {
      name: 'Baselayer',
      url: 'https://baselayer.com',
      logo: '/logos/baselayer.svg',
      tagline: 'Business identity verification'
    },
    {
      name: 'Nitra',
      url: 'https://nitra.com',
      logo: '/logos/nitra.svg',
      tagline: 'AI to run your practice'
    },
    {
      name: 'Flipturn',
      url: 'https://getflipturn.com',
      logo: '/logos/flipturn.svg',
      tagline: 'EV charging for enterprises'
    },
    {
      name: 'Vellum',
      url: 'https://vellum.ai',
      logo: '/logos/vellum.svg',
      tagline: 'Build AI agents in plain English'
    },
    {
      name: 'Omneky',
      url: 'https://omneky.com',
      logo: '/logos/omneky.svg',
      tagline: 'AI ad campaign optimization'
    },
    {
      name: 'Instabase',
      url: 'https://instabase.com',
      logo: '/logos/instabase.svg',
      tagline: 'Documents into verifiable intelligence'
    },
    {
      name: 'Ansa',
      url: 'https://ansabio.com',
      logo: '/logos/ansa.png',
      tagline: 'Enzymatic DNA synthesis'
    },
    {
      name: 'True Markets',
      url: 'https://truemarkets.co',
      logo: null,
      tagline: 'Stablecoin-native DeFi trading'
    },
    {
      name: 'Slingshot AI',
      url: 'https://slingshotai.com',
      logo: '/logos/slingshot.svg',
      tagline: 'AI for mental health'
    },
    {
      name: 'Pangea Bio',
      url: 'https://pangeabio.com',
      logo: '/logos/pangea.png',
      tagline: 'CNS drug discovery platform'
    },
    {
      name: 'Magna',
      url: 'https://magna.so',
      logo: '/logos/magna.svg',
      tagline: 'Digital asset management for Web3'
    },
    {
      name: 'Reference Medicine',
      url: 'https://referencemedicine.com',
      logo: '/logos/reference-medicine.webp',
      tagline: 'Hassle-free oncology specimens'
    },
    {
      name: 'Mana Finance',
      url: 'https://linkedin.com/company/manafinance',
      logo: null,
      tagline: 'AI financial intelligence'
    },
    {
      name: 'OpenGradient',
      url: 'https://opengradient.ai',
      logo: '/logos/opengradient.png',
      tagline: 'Infrastructure for verifiable AI'
    },
    {
      name: 'Revoy',
      url: 'https://revoy.com',
      logo: '/logos/revoy-new.png',
      tagline: 'Electric battery swap for trucks'
    },
    {
      name: 'CoFrame',
      url: 'https://coframe.com',
      logo: '/logos/coframe.svg',
      tagline: 'AI website optimization'
    },
    {
      name: 'ZBiotics',
      url: 'https://zbiotics.com',
      logo: '/logos/zbiotics.svg',
      tagline: 'Drink before drinking'
    },
    {
      name: 'Shennon Bio',
      url: 'https://shennonbio.com',
      logo: '/logos/shennon.svg',
      tagline: 'Single-cell immune profiling'
    },
    {
      name: 'Basis',
      url: 'https://getbasis.ai',
      logo: '/logos/basis.svg',
      tagline: 'AI agents for accountants'
    },
    {
      name: 'Credal',
      url: 'https://credal.ai',
      logo: '/logos/credal.svg',
      tagline: 'Secure AI agent platform'
    },
    {
      name: 'Escalante',
      url: 'https://escalante.bio',
      logo: null,
      tagline: 'Biotech innovation'
    },
    {
      name: 'Optimum',
      url: 'https://getoptimum.xyz',
      logo: '/logos/optimum.svg',
      tagline: 'High-performance blockchain memory'
    },
    {
      name: 'Bond Studio',
      url: 'https://bondstudio.ai',
      logo: '/logos/bond.svg',
      tagline: 'AI-powered space scanning'
    },
    {
      name: 'Cardinal Gray',
      url: 'https://cardinalgray.com',
      logo: null,
      tagline: 'Automate title work for lenders'
    },
    {
      name: 'Fundify AI',
      url: 'https://fundify.ai',
      logo: null,
      tagline: 'AI-powered grant automation'
    },
    {
      name: 'Paramark',
      url: 'https://paramark.com',
      logo: '/logos/paramark.svg',
      tagline: 'Marketing measurement platform'
    },
    {
      name: 'Polimorphic',
      url: 'https://polimorphic.com',
      logo: '/logos/polimorphic.svg',
      tagline: 'AI for government services'
    },
    {
      name: 'Reach',
      url: 'https://embedreach.com',
      logo: null,
      tagline: 'Add marketing tools to your SaaS'
    },
    {
      name: 'Hyperion',
      url: 'https://hyperionlabs.xyz',
      logo: '/logos/hyperion.svg',
      tagline: 'Auditable financials for Web3'
    },
    {
      name: 'Serene Sleep',
      url: 'https://serenesleep.com',
      logo: '/logos/serene-sleep.svg',
      tagline: 'Implant for snoring and sleep apnea'
    }
  ];

  return (
    <div className="portfolio">
      <div className="portfolio-content">
        <div className="companies-grid">
          {companies.map((company) => (
            <a
              key={company.name}
              href={company.url}
              target="_blank"
              rel="noreferrer"
              className="company-card"
            >
              <div className="company-logo-container">
                {company.logo ? (
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="company-logo"
                  />
                ) : (
                  <div className="company-logo-text">
                    {company.name}
                  </div>
                )}
              </div>
              <div className="company-info">
                <p className="company-tagline">{company.tagline}</p>
                <p className="company-url">{company.url.replace(/^https?:\/\//, '').replace(/\/$/, '')}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
